import PropTypes from 'prop-types'

import ShadowWrapper from '../ShadowWrapper'

import './organizationCobrandingFirmSettings.scss'

const buildQueryString = params => Object.entries(params)
  .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value ?? '')}`)
  .join('&')

const buildPreviewPath = queryString => {
  if (typeof window === 'undefined')
    return `#/organization_cobranding_preview?${queryString}`

  return `${window.location.origin}/external/#/organization_cobranding_preview?${queryString}`
}

const OrganizationCobrandingFirmSettings = ({firm, organizationCobranding}) => {
  const organizationId = firm?.organization_id

  let previewLink = null

  if (organizationCobranding?.enabled) {
    previewLink = buildPreviewPath(
      buildQueryString({
        firmId: firm?.id ?? '',
        organization_id: organizationId ?? ''
      })
    )
  }

  return (
    <ShadowWrapper>
      <div className='organization-cobranding-firm-settings settings row-wrapper'>
        <p>Status: </p>
        <div className='column-wrapper'>
          <p>Organization Cobranded</p>
          <p className='description'>
            This firm is a part of an organization that has organization
            cobranding enabled. The firm will use the colors specified in the
            organization's cobranding settings.
          </p>
          {previewLink && (
            <a
              className='organization-cobranding-preview-link'
              href={previewLink}
              rel='noreferrer'
              target='_blank'>
              Open preview in new window
            </a>
          )}
        </div>
      </div>
    </ShadowWrapper>
  )
}

OrganizationCobrandingFirmSettings.propTypes = {
  firm: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    organization_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  organizationCobranding: PropTypes.shape({enabled: PropTypes.bool})
}

export default OrganizationCobrandingFirmSettings
